module.exports = __webpack_public_path__ + "static/media/kake_yellow-min.e7b1fb8f.png";